import React, { useEffect, useState } from 'react';
import { DashboardHeader } from './DashboardHeader';
import { PageWrapper } from '../Shared/Containers/PageWrapper';
import styled from 'styled-components';
import { DashboardCard } from './DashboardCard';
import { breakpoint } from '../../projlibs/breakpoints';
import { DASHBOARD_HEADER_HEIGHT } from '../../constants/style-size-constants';
import { MakePaymentBox } from './MakePaymentBox';
import {useLocation} from "react-router-dom";
import {set_cookie, parse_cookies} from "../../projlibs/cookie-management";
import {ACCESS_TOKEN, UNION_NUMBER} from "../../constants/cookie-constants";
import { PaymentInfo } from './PaymentInfo';
import { API } from '../../projlibs/api';
export const RightSidebar = styled.div`
	margin-left: 32px;
	margin-top: 32px;
	${breakpoint('medium down')} {
		margin: 0;
		padding: 0 32px;
	}
	//width: 30%;
`;
export const PageContent = styled.div`
	margin: ${DASHBOARD_HEADER_HEIGHT} 10% 0 10%;
	display:inline-flex;
	width:80%;
	height:100%;
	padding-top:32px;
	flex-direction: row-reverse;
	${breakpoint('medium down')} {
		margin: ${DASHBOARD_HEADER_HEIGHT} 0 0 0;
		width:100%;
		flex-direction:column;
	}
`;
function useQuery() {
	return new URLSearchParams(useLocation().search);
}
export const Dashboard = props => {
	const query = useQuery()
	const accessToken = query.get('access_token')
	if (accessToken){
		set_cookie(ACCESS_TOKEN, accessToken);
	}

	// State for pagination and data
	const [page, setPage] = useState(1);
	const [pageSize,] = useState(10);
	const [totalPages, setTotalPages] = useState(1);
	const [orderBy,] = useState('s_field=paidon&s_order=D');
	const [paymentData, setPaymentData] = useState(null);
	const [loading, setLoading] = useState(true);
	
	// Individual state for PaymentInfo
	const [currentBalance, setCurrentBalance] = useState(0);
	const [paidUpLabel, setPaidUpLabel] = useState('');
	const [balanceLabel, setBalanceLabel] = useState('');
	const [amountSubscriptLabel, setAmountSubscriptLabel] = useState('');

	useEffect(()=>{
		
		window.scrollTo({top: 0, behavior: 'smooth'});
	},[]);

	// Consolidated API call
	useEffect(() => {
		setLoading(true);
		API.get(`/v2/payments/history?page=${page-1}&page_size=${pageSize}&${orderBy}`).then(({ data }) => {
			setPaymentData(data);
			setTotalPages(data.TotalPages || 1);
			
			// Extract individual values for PaymentInfo
			setCurrentBalance(data.BalanceAmount);
			setBalanceLabel(data.BalanceLabel);
			setAmountSubscriptLabel(data.AmountSubscriptLabel);
			setPaidUpLabel(data.PaidUpLabel);
		}).catch(err => {
			console.log(err);
			let cookies = parse_cookies();
			// note that any response will be logged inside API.default_error_handler and forwarded to datadog
			// this is just to save request params
			window.DD_LOGS.logger.error('Get payment history failed.', { union_number: cookies[UNION_NUMBER] });
			API.default_error_handler(err);
		}).finally(() => {
			setLoading(false);
		});
	}, [page, pageSize, orderBy]);

	return (
		<PageWrapper width='100%' className='page-wrapper'>
			<DashboardHeader className='dashboard-container' />
			<PageContent>
			<RightSidebar>
				<PaymentInfo 
					currentBalance={currentBalance}
					paidUpLabel={paidUpLabel}
					balanceLabel={balanceLabel}
					amountSubscriptLabel={amountSubscriptLabel}
					loading={loading}
				/>
				<MakePaymentBox className='make-payment-box' />
			</RightSidebar>
			
			<DashboardCard 
				paymentData={paymentData}
				loading={loading}
				page={page}
				setPage={setPage}
				totalPages={totalPages}
			/>

			</PageContent>
		</PageWrapper>
	);
};
